module.exports = __webpack_public_path__ + "img/d2hk_CLS.4bab2950.svg";